module.exports = __webpack_public_path__ + "static/media/term-calendar.b51466e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/guide/term-calendar.svg
// module id = 579
// module chunks = 0